module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/eye-visible-icon.e53f34ee.svg";